export default __webpack_public_path__ + "static/sampleimage1-dc9f7fc9e88e5b4a372404cefe36a8b3.svg";